module.exports = __webpack_public_path__ + "img/box-fight.036e43fe.png";